module.exports = __webpack_public_path__ + "img/help.8f07e757.svg";